module.exports = __webpack_public_path__ + "img/002徐向南.8de7be92.png";